import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'top-panel',
  imports: [],
  templateUrl: './top-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './top-panel.component.scss',
})
export class TopPanelComponent {}
